import { Component, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { AppService } from '../app.service';
import { CountryISO } from 'ngx-intl-tel-input';
import { environment } from 'src/environments/environment';
import { Router} from "@angular/router";


declare var $;
declare var gtag;
declare var fbq;
@Component({
  selector: 'app-request-callback',
  templateUrl: './request-callback.component.html',
  styleUrls: ['./request-callback.component.css']
})

export class RequestCallbackComponent implements OnInit {
  public feedbackInfoForm:boolean=true;
  public feedbackOtpForm:boolean=false;
  public feedbackThankForm:boolean=false;
  CountryISO = CountryISO;


  constructor(private fb: FormBuilder, private service: AppService,private router: Router) { }

  ngOnInit() {
    // if (isPlatformBrowser(this.platformId)) {
    //   // $(".call-connect").click(function () {
    //   //   $(".call-menu").toggleClass("active");
    //   // });

    //   $(window).scroll(function () {
    //     if ($(window).scrollTop() >= 800) {
    //       $('.static-ad').addClass('show-static-ad');
    //     }
    //     else {
    //       $('.static-ad').removeClass('show-static-ad');
    //     }
    //     $(".call-menu").removeClass("active");
    //   });

    //   $('.feedback-first input:radio').change(function () {
    //     if ($(this).is(":checked")) {
    //       $('.feedback-form').addClass("feedback-second-show");
    //     }
    //   });
    // }
    if(environment.production){
      this.service.sendEvents("Completerequestcallback", "requestcallback", "RequestCallBack");

      fbq('track', "CompleteRequestCallBack" , {
        content_type: "requestcallback",
        content_title: this.router.url,
      });
    }

    this.callback.get("contact").valueChanges.subscribe((val)=>{
      if(val){
        this.callback.patchValue({
          phone_code:val.dialCode,
          phone:val.number

        })        
      }
    })

    this.service.setTitle('Get in touch with propira');
    this.service.setMetaTags({ property: "og:type", content: 'Property' });
    this.service.setMetaTags({ property: "og:title", content: 'Get in touch with propira' });
    this.service.setMetaTags({ name: "keywords", content: 'Get in touch with propira' });
    this.service.setMetaTags({ name: "description", content: 'Get in touch with propira' });
    this.service.setMetaTags({ property: "og:description", content: 'Get in touch with propira' }); 
     
  }
  

  // openFeedbackForm(){
  //   $(".feedback-form").toggleClass("feedback-show");
  //   $('.feedback-form').removeClass("feedback-second-show");
  //   $('input[name="feedback"]').prop('checked', false);
  //   this.feedbackSubmit=false;
  //   this.feedbackErrorMsg="";
  //   this.feedbackSuccessMsg="";
  //   this.feedback.reset();
  //   this.feedbackverify.reset();
  // }

  callback = this.fb.group({
    name:['',[Validators.required,Validators.pattern('^[a-zA-Z ]*$')]],
    phone:['',[Validators.required]],
    message: [''],
    phone_code:['91'],
    contact:['']
  });

  get callbackControl() { return this.callback.controls; }

  callbackSubmit: boolean = false;
  callbackLoader: boolean = false;
  callbackErrorMsg: string = "";
  callbackSuccessMsg: string = "";
  callbackEnd() {
    var selectedCityData = JSON.parse(localStorage.getItem('selSearchCity'));
    this.callbackErrorMsg = "";
    this.callbackSuccessMsg = "";
    this.callbackSubmit = true;

    if (this.callback.valid) {
      this.callbackLoader = true;
      this.callback.patchValue({
        phone : this.callback.value.phone.replace(/\s+/g, '')
      })
      console.log(this.callback.value);
      this.service.post('/callbackEnd', this.callback.value).subscribe(
        (data: any) => {
          if (data[0].error == '0') {
            this.callbackSuccessMsg = data[0].msg;
            if (environment.production) {
              const eventID = [selectedCityData.name,data[0].id];
                gtag('config', environment.gtagId, {
                  'page_path': 'https://www.propira.com/request-to-callback'
                });
                this.service.sendEvents("Contact", this.callback.value.message,this.callback.value.name);
                fbq('init', environment.fbId, {
                  'track': 'https://www.propira.com/request-to-callback'
                });
                fbq('track', "Contact" , {
                  content_ids:eventID,
                  content_name:this.callback.value.name,
                  contents:this.callback.value.message
                });     
            }
            this.callback.reset();
            this.callbackSubmit = false;
          } else {
            this.callbackErrorMsg = data[0].msg;
          }

          this.callbackLoader = false;
        }, (error: any) => {
          this.callbackErrorMsg = error.errorDesc;
          this.callbackLoader = false;
        }
      )
    }
  } 
}

